module.exports = __webpack_public_path__ + "img/xpu-ha-room-3.4087ca58.jpg";